import { useEffect, useState } from "react";
import { getAllProducts } from "../services";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

export const useLoadingProducts = () => {
const [data, setData] = useState([]);
const history = useHistory();

const getProducts = async () => {
  try{

	const response = await getAllProducts()
    
  setData(response.data);
			
	}catch(error){
		toast.error("Erro ao buscar produtos");
	}
  };

  useEffect(() => {
    getProducts();
  }, []);

const navigateViewProduct = (productId) => {

	 history.push(`/produtos/${productId}`);
}
return { data, navigateViewProduct}

}
